module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Access denied","description":"This form has an IP filter and we didn\u0027t find yours in the list.","developed":"Developed by","wepipe-forms":"wepipe forms"},"pt-BR":{"title":"Acesso negado","description":"Esse formulário possui filtro por IP e não encontramos o seu na lista.","developed":"Desenvolvido por","wepipe-forms":"wepipe forms"}}')
  delete Component.options._Ctor
}
